<template>

    <g class="lamp">
      <g id="lamp_">

        <circle id="lamp_faer" opacity="0.69" fill="#FFFF00" cx="959.9" cy="144.7" r="21.4"/>

        <g id="lamp_light" class="lamp--light">
          <polygon id="lamp_light" opacity="0.05" fill="#FFFF00" points="871.8,171.8 1048.1,172.4 1969,1991 -47.5,1991 	"/>
          <polygon fill="#42B27C" points="-688.2,492.7 -688.4,492.6 -688.1,492.6 "/>
          <polygon opacity="0.1" fill="#FFFF00" enable-background="new" points="1844.9,2009.6 77.3,2009.6 872,171.8 1048.1,172.4 "/>
        </g>
        <g id="lamp_main">
          <path id="lamp_border" :class="{ 'lamp--border': selectLamp }" fill="#4CC18E" d="M1048,172.3c-12.6-26.2-36.4-45.8-65.4-52.7l0,0l-4.7-37.7c-0.4-3.1-3-5.4-6.1-5.4l-13.8,0l-9.4,0
                c-3.1,0-5.7,2.3-6.1,5.4l-5,37.6h0c-28.9,6.7-52.9,26.3-65.7,52.3l58.3,0.2l-0.1,0.1c1.6,3.4,3.9,6.6,6.6,9.2
                c6,6,14.4,9.7,23.5,9.7c9.1,0,17.4-3.7,23.4-9.6c2.7-2.6,5-5.8,6.6-9.2L1048,172.3z M990.2,172.1L990.2,172.1L990.2,172.1
                L990.2,172.1z"/>
          <polygon fill="#42B27C" points="990.2,172.2 990.1,172.1 990.2,172.1 	"/>
          <path id="lamp_verevka" fill="none" stroke="#E5A030" stroke-width="10" stroke-miterlimit="10" d="M959.9,16.3c0,13.7,0,27.3,0,41
                c0,7.6,0,15.3,0,22.9"/>

          <g id="lamp_red">
            <path fill="#F24125" d="M960.3,137.8c-7.8,0-21-5.5-22.6-18.3l5-37.6c0.4-3.1,3-5.3,6.1-5.4l9.4,0l13.8,0c3.1,0,5.7,2.3,6.1,5.4
                  l4.7,37.7C988.5,132.8,968,137.8,960.3,137.8z"/>
            <path fill="#DD3B2A" d="M958.1,76.5l-5.4,46.5c-4.7,0.3-9.4-4.8-14-3.8h0c-0.1,0-0.3,0.1-0.4,0.1c-0.1,0-0.2,0-0.3,0.1c0,0,0,0,0,0
                  s-0.1,0-0.1,0c0,0-0.1,0-0.1,0h0c0,0-0.1,0-0.1,0l5-37.6c0.4-3.1,3-5.3,6.1-5.4L958.1,76.5z"/>
          </g>

          <g id="lamp_green">
            <path id="lamp_mainsnr" fill="#F7B239" d="M990.3,172.2c-1.7,3.4-4,6.6-6.6,9.2c-6,5.9-14.3,9.6-23.4,9.6c-9.2,0-17.5-3.7-23.5-9.7
                  c-2.7-2.6-5-5.8-6.6-9.2l30.9-20.7L990.3,172.2"/>
            <path fill="#4CC18E" d="M1048.1,172.4l-57.9-0.2l0-0.1h-29.4l-88.9-0.3c12.8-26.1,36.8-45.6,65.7-52.3c7.2-1.7,14.8-2.6,22.6-2.5
                  c7.8,0,15.3,1,22.6,2.7C1011.7,126.5,1035.6,146.2,1048.1,172.4"/>
            <path id="lamp_snr" fill="#E5A030" d="M960.9,172.1h-30.9c1.7,3.4,3.9,6.6,6.6,9.2l24.2,0.1h22.8c2.7-2.6,5-5.8,6.6-9.2L960.9,172.1"/>
            <path fill="#42B27C" d="M959.9,116.9L959.9,116.9L959.9,116.9c-2.4,0-4.8,0.1-7.2,0.3c-4.7,0.3-9.4,1-13.9,2l0,0c0,0,0,0,0,0l0,0
                  c-0.1,0-0.3,0.1-0.4,0.1l0,0c-0.3,0.1-0.5,0.1-0.7,0.2l0,0l0,0l0,0c-28.9,6.7-52.9,26.3-65.7,52.3h29.5
                  c12.8-26.1,36.8-45.6,65.7-52.3c2.5-0.6,5-1,7.5-1.5c-3.9-0.6-7.8-0.9-11.8-1.1l0,0c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0s0,0-0.1,0
                  s-0.1,0-0.1,0l0,0c-0.1,0-0.1,0-0.2,0l0,0c-0.6,0-1.2,0-1.8,0l0,0c-0.1,0-0.1,0-0.2,0l0,0C960.1,116.9,960,116.9,959.9,116.9
                  L959.9,116.9L959.9,116.9L959.9,116.9"/>
          </g>

          <polygon id="lamp_faer" fill="#42B27C" points="-688.2,492.7 -688.4,492.6 -688.1,492.6 "/>
        </g>
      </g>
      <g>
        <path fill="#4CC18E" d="M930.1,0h60.3c-5.4,11.2-16.9,18.9-30.1,18.9l0,0C947,18.9,935.5,11.2,930.1,0"/>
        <path fill="#42B27C" d="M948.1,0h-18.1c5.4,11.2,16.9,18.9,30.1,18.9l0,0l0,0c3.1,0,6.2-0.4,9-1.2C960,15.1,952.3,8.5,948.1,0"/>
      </g>
    </g>

</template>

<script>
    import { TimelineMax, Power0 } from 'gsap'

    export default {
      data: function () {
        return {
          tl:undefined,
        }
      },
      mounted() {
        this.tl = new TimelineMax({repeat:-1});
      },
      props: {
        select: {
          type: Boolean,
          required: true
        }
      },
      computed: {
        selectLamp() {
          return this.select;
        }
      },
      methods: {
        crash() {
          const tl = new TimelineMax();
          tl.set('#lamp_border',{opacity:0})
          tl.to('#lamp_faer', 0.1, {scale:5, transformOrigin:"center"})
          tl.to('#lamp_faer', 0.5, {scale:6, opacity:0, transformOrigin:"center"})
          tl.to('#lamp_light', 0.1, {opacity:0}, '-=0.6')
          tl.to('#lamp_verevka', 0.1  , {opacity:0}, '-=0.6')
          tl.to('#lamp_red', 1.5, {x:-300,  ease: Power0.easeNone, y:2000, rotation:100, transformOrigin:"center"}, '-=0.6')
          tl.to('#lamp_red', 0.25, {opacity:0},'-=0.4')
          tl.to('#lamp_green', 1.5, {x:300,  ease: Power0.easeNone, y:2000, rotation:-200, transformOrigin:"center"}, '-=1.5')
          tl.to('#lamp_green', 0.25, {opacity:0},'-=0.45')

        },
        start() {
          this.tl.set('#lamp_', {rotation: 4,x:-3, y:-20, transformOrigin:"start"});
          this.tl.to('#lamp_', 2.7, {rotation: -4, x:3, y:22,  ease: Power0.easeNone, transformOrigin:"start", delay:0.1});
          this.tl.to('#lamp_', 2.7, {rotation: 4, x:-3, y:-20, ease: Power0.easeNone, transformOrigin:"start", delay:0.1});
        },
        stop() {
          this.tl.kill();
        }
      }
    }

</script>

<style lang="scss">

    .lamp {
        &--border {
            stroke: yellow;
            stroke-width: 20;
        }
    }

</style>
